import { render, staticRenderFns } from "./EmployeeInspectionRequests.vue?vue&type=template&id=55d54176&scoped=true"
import script from "./EmployeeInspectionRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeInspectionRequests.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeInspectionRequests.vue?vue&type=style&index=0&id=55d54176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d54176",
  null
  
)

export default component.exports